/* eslint-disable prefer-promise-reject-errors */

import React, { useCallback, useEffect } from 'react'
import { connect } from 'dva'
import { pick } from 'lodash'
import {
  Modal,
  Form,
  Input,
  Button,
  Checkbox,
  // Upload, Col, Row, message
} from 'antd'
import { Link } from 'react-router-dom'
import { idCardValidator, bankCardValidator, phoneValidator } from '@/utils'

// import IconFont from '@/components/Icon'
import './Info.module.less'

const layout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 19 },
}

const AddBankCard = ({ dispatch, bankCardVisible, isEditBank, editBank }) => {
  // const [frontImageUrl, setFrontImageUrl] = useState('')
  // const [backImageUrl, setBackImageUrl] = useState('')

  const [form] = Form.useForm()

  useEffect(() => {
    if (bankCardVisible && isEditBank) {
      form.setFieldsValue({
        realname: editBank.realname,
        phone: editBank.phone,
        idCard: editBank.idCard,
        cardNumber: editBank.cardNumber,
        bankName: editBank.bankName,
        idFront: editBank.idFront,
        idBack: editBank.idBack,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bankCardVisible, isEditBank])

  const handleCancel = useCallback(() => {
    dispatch({
      type: 'center/save',
      payload: {
        bankCardVisible: false,
      },
    })
    form.resetFields()
    // setFrontImageUrl('')
    // setBackImageUrl('')
  }, [form, dispatch])

  const onFinish = (values) => {
    const data = pick(values, [
      'realname',
      'phone',
      'idCard',
      'cardNumber',
      'bankName',
      'isDefault',
    ])
    const payload = {
      body: data,
      query: {},
    }
    if (values.idFront && values.idFront[0]) {
      payload.body.idFront = values.idFront[0].originFileObj
    }
    if (values.idBack && values.idBack[0]) {
      payload.body.idBack = values.idBack[0].originFileObj
    }

    // 编辑添加id
    if (isEditBank) {
      payload.query = {
        id: editBank.id,
      }
    } else {
      payload.body.isDefault = 0
    }
    dispatch({
      type: isEditBank
        ? 'center/editPersonalBankCard'
        : 'center/addPersonalBankCard',
      payload,
    }).then(() => {
      handleCancel()
      dispatch({
        type: 'global/getPersonalBankCards',
      })
    })
  }
  const onAgreeChange = (e) => {
    form.setFieldsValue({
      agree: e.target.checked ? true : undefined,
    })
  }
  // const normFile = e => {
  //   if (Array.isArray(e)) {
  //     return e
  //   }
  //   return e && e.fileList
  // }

  // const getBase64 = (img, callback) => {
  //   const reader = new FileReader()
  //   reader.addEventListener('load', () => callback(reader.result))
  //   reader.readAsDataURL(img)
  // }

  // const beforeUpload = (file, direction) => {
  //   const isJpgOrPng = file.type === 'image/jpeg'
  // || file.type === 'image/png'
  //   if (!isJpgOrPng) {
  //     message.error('请选择JPG/PNG格式的图片')
  //     return
  //   }
  //   const isLt2M = file.size / 1024 / 1024 < 4
  //   if (!isLt2M) {
  //     message.error('请选择小于4MB的图片')
  //     return
  //   }
  //   getBase64(file, imageUrl => {
  //     if (direction === 'front') {
  //       setFrontImageUrl(imageUrl)
  //     } else {
  //       setBackImageUrl(imageUrl)
  //     }
  //   })
  //   // eslint-disable-next-line consistent-return
  //   return false
  // }

  // const handleChange = (info, direction) => {
  //   if (info.file.status === 'uploading') {
  //     return
  //   }
  //   if (info.file.status === 'done') {
  //     console.log(222)
  //     console.log(info)
  //     // Get this url from response in real world.
  //     getBase64(info.file.originFileObj, imageUrl => {
  //       console.log(imageUrl)
  //       console.log(info)
  //       if (direction === 'front') {
  //         setFrontImageUrl(imageUrl)
  //       } else {
  //         setBackImageUrl(imageUrl)
  //       }
  //     })
  //   }
  // }

  return (
    <Modal
      className="modal"
      width={738}
      title="收款信息"
      visible={bankCardVisible}
      footer={null}
      onCancel={handleCancel}
    >
      <Form
        {...layout}
        name="basic"
        labelAlign="left"
        form={form}
        initialValues={{ remember: true }}
        onFinish={onFinish}
      >
        <Form.Item
          label="真实姓名"
          name="realname"
          rules={[{ required: true, message: '请输入真实姓名' }]}
        >
          <Input placeholder="请输入真实姓名" />
        </Form.Item>

        <Form.Item
          label="手机号码"
          name="phone"
          rules={[{ required: true, validator: phoneValidator }]}
        >
          <Input placeholder="请输入手机号码" />
        </Form.Item>
        <Form.Item
          label="身份证号"
          name="idCard"
          rules={[{ required: true, validator: idCardValidator }]}
        >
          <Input placeholder="请输入身份证号" />
        </Form.Item>
        <Form.Item
          label="银行卡号"
          name="cardNumber"
          rules={[{ required: true, validator: bankCardValidator }]}
        >
          <Input placeholder="请输入银行卡号" />
        </Form.Item>
        <Form.Item
          label="开户支行"
          name="bankName"
          rules={[{ required: true, message: '请输入开户支行' }]}
        >
          <Input placeholder="请具体到支行，如：招商银行北京市海淀区清华科技园支行" />
        </Form.Item>
        <Form.Item
          name="agree"
          rules={[
            {
              required: true,
              message: '请同意隐私协议',
            },
          ]}
        >
          <span style={{ color: '#ff8534', marginRight: '8px' }}>*</span>
          <Checkbox onChange={onAgreeChange}>
            同意
            <Link to="/policy/privacy" style={{ color: '#056DE8' }}>
              隐私协议
            </Link>
          </Checkbox>
        </Form.Item>
        {/* <Row>
          <Col span={12}>
            <Form.Item
              label="身份证照片"
              name="idFront"
              valuePropName="fileList"
              getValueFromEvent={normFile}
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 16 }}
              rules={[{ required: !isEditBank, message: '请上传身份证正面照片' }]}
            >
              <Upload
                className="id-card"
                name="avatar"
                listType="picture-card"
                showUploadList={false}
                // action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                beforeUpload={file => beforeUpload(file, 'front')}
              >
                {frontImageUrl
                  ? <img src={frontImageUrl}
                   alt="avatar" styleName="upload-image" />
                  : (
                    <div styleName="card empty bank-card">
                      <IconFont styleName="icon" type="iconzengjia" />
                      <span>身份证正面</span>
                    </div>
                  )}
              </Upload>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label=""
              name="idBack"
              valuePropName="fileList"
              getValueFromEvent={normFile}
              labelCol={{ span: 0 }}
              wrapperCol={{ span: 24 }}
              rules={[{ required: !isEditBank, message: '请上传身份证背面照片' }]}
            >
              <Upload
                name="avatar"
                listType="picture-card"
                className="id-card"
                showUploadList={false}
                // action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                beforeUpload={file => beforeUpload(file, 'back')}
              >
                <div style={{ marginLeft: '64px' }}>
                  {backImageUrl
                    ? <img src={backImageUrl}
                     alt="avatar" styleName="upload-image" />
                    : (
                      <div styleName="card empty bank-card">
                        <IconFont styleName="icon" type="iconzengjia" />
                        <span>身份证反面</span>
                      </div>
                    )}
                </div>
              </Upload>
            </Form.Item>
          </Col>
        </Row> */}
        <div style={{ marginTop: '30px', textAlign: 'center' }}>
          <Button style={{ width: '88px' }} type="primary" htmlType="submit">
            保存信息
          </Button>
        </div>
      </Form>
    </Modal>
  )
}

export default connect(({ center }) => {
  return {
    bankCardVisible: center.bankCardVisible,
    isEditBank: center.isEditBank,
    editBank: center.editBank,
  }
})(AddBankCard)
